import * as Styled from 'components/nav-link/styled';

type NavLinkProps = Styled.NavLinkProps;

const NavLink = Styled.NavLink;
const NavTabStyles = Styled.NavTabStyles;
const MarkableNavLink = Styled.MarkableNavLink;

const Root = NavLink;
const Markable = MarkableNavLink;

export {
    NavLink,
    NavTabStyles,
    MarkableNavLink,
    //
    Root,
    Markable,
};
export type { NavLinkProps };
